import React from "react";
import { ArrowRight, Globe, Cpu, Leaf } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheInaraPhilosophy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-inara-philosophy" ref={sectionRef} className="dark bg-background text-foreground relative w-full overflow-hidden py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {}
          <div className={`lg:col-span-8 relative rounded-3xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative aspect-[4/3] md:aspect-[16/9] lg:aspect-[16/10] w-full">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/nairobi_office_interior_blue_overlay.png" alt="Inara Technologies Nairobi Office Interior" className="absolute inset-0 h-full w-full object-cover" />
              {}
              <div className="absolute inset-0 bg-blue-950/60 mix-blend-multiply" />
              <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-transparent to-transparent lg:hidden" />
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 lg:col-start-8 lg:-ml-12 relative z-10 mt-[-10%] lg:mt-0 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <Card className="bg-card/95 backdrop-blur-md border-primary/20 shadow-2xl overflow-hidden">
              <CardContent className="p-8 md:p-10 flex flex-col gap-6">
                <div className="flex items-center justify-between">
                  <Badge variant="outline" className="border-primary/50 text-primary px-3 py-1 text-xs uppercase tracking-widest">
                    Nairobi-Born
                  </Badge>
                  <Globe className="text-muted-foreground h-5 w-5 opacity-50" />
                </div>

                <div className="space-y-4">
                  <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground">
                    Sustainable Growth through{" "}
                    <span className="text-primary">Intelligent Innovation</span>
                  </h2>
                  <p className="text-muted-foreground text-lg leading-relaxed font-sans">
                    At Inara Technologies, we bridge the gap between traditional
                    enterprise stability and the high-velocity world of AI. Our
                    philosophy is simple: technology must serve humanity. We
                    empower businesses across Kenya and East Africa to optimize,
                    automate, and scale with purpose.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 py-4">
                  <div className="flex flex-col gap-2 p-4 rounded-xl bg-secondary/30 border border-border/50">
                    <Cpu className="h-6 w-6 text-primary mb-1" />
                    <span className="text-sm font-medium text-foreground">
                      AI-Driven Efficiency
                    </span>
                  </div>
                  <div className="flex flex-col gap-2 p-4 rounded-xl bg-secondary/30 border border-border/50">
                    <Leaf className="h-6 w-6 text-chart-2 mb-1" />
                    <span className="text-sm font-medium text-foreground">
                      Sustainable Impact
                    </span>
                  </div>
                </div>

                <div className="pt-2">
                  <Button asChild size="lg" className="w-full sm:w-auto group">
                    <Link to="/PhilosophyPage">
                      Discover Our Approach
                      <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}